import React, { Fragment } from "react";
import InfiniteScrollTable from "../../infinite-scroll-table";
import {Input, Radio} from "antd";
import {translate} from "react-i18next";

import {compose} from "redux";
import {
  EL_COL_TYPE_IGNORE,
  EL_COL_TYPE_TRANSLATION,
  EL_SEMANTIC_CONCEPT_EXISTING,
  EL_SEMANTIC_CONCEPT_NEW,
  getELSemanticConceptTypeTranslations,
} from "../constants";
import Selector from "../../selector";
import PerfInput from "../../perf-input";
import DataLanguageSelector from "../../data-language-selector";
import { MARGIN_MD } from "../../../styles/constants";

const TABLE_COL_WIDTH = 200;
const TABLE_COL_SELECTOR_WIDTH = 400;
const LANG_SELECTOR_WIDTH = 90;

const inputStyle = {
  marginRight: MARGIN_MD, 
  width: `calc(100% - ${LANG_SELECTOR_WIDTH}px - ${MARGIN_MD}px`
};


const ELSemanticStepTable = ({
                              t, 
                              structureColumns, 
                              canCreateConcepts,
                              setColumnIdToAssociateConceptSchema,
                              onChange
                            }) => {

  const semanticColumns = (structureColumns || []).filter( column =>
      column.type !== EL_COL_TYPE_IGNORE &&
      column.type !== EL_COL_TYPE_TRANSLATION
  );

  const conceptsCreationColumns = [
    {
      dataIndex: "conceptType",
      title: t("components.easyLoading.semantic.table.conceptType.title"),
      width: TABLE_COL_WIDTH,
      noFilter: true,
      noSort: true,
      render: (conceptType, row) => (
        <Radio.Group                               
          onChange={e => onChange(row.id, e.target.value, null, null, null, null)} 
          value={conceptType}                
        >
          {[
          EL_SEMANTIC_CONCEPT_NEW,
          EL_SEMANTIC_CONCEPT_EXISTING
        ].map(opt =>
          <Radio
            key={opt}
            value={opt}                
            >
            {getELSemanticConceptTypeTranslations(t)[opt]}
          </Radio>
        )}
        </Radio.Group>
      ),
      renderText: () => null
    },
    {
      dataIndex: "semanticDefinition",
      width: TABLE_COL_SELECTOR_WIDTH,
      noFilter: true,
      noSort: true,
      render: (semanticDefinition, row) => {
        if (semanticDefinition.conceptType === EL_SEMANTIC_CONCEPT_NEW) {
          const newConcept = semanticDefinition.newConcept;
          const lang = semanticDefinition.currentLang;
          const name = newConcept[lang] || "";
          return (
            <Fragment>
              <PerfInput
                Component={Input}
                style={inputStyle}
                value={name}
                onChange={value => 
                  onChange(row.id, EL_SEMANTIC_CONCEPT_NEW, value, lang, null, null)
                }
              />
              <DataLanguageSelector 
                  value={semanticDefinition.currentLang} 
                  showLangCode
                  style={{width: LANG_SELECTOR_WIDTH}}
                  onSelect={lang => {
                      onChange(row.id, EL_SEMANTIC_CONCEPT_NEW, newConcept[lang] || "", lang, null, null)
                    }                    
                  }
                  
              />
            </Fragment>
          );
        } else if (semanticDefinition.conceptType === EL_SEMANTIC_CONCEPT_EXISTING) {
          return (
            <Fragment>
              <Selector
                selectTitle={t('components.easyLoading.semantic.table.conceptScheme.selector.selectTitle')}
                resetTitle={t('components.easyLoading.semantic.table.conceptScheme.selector.resetTitle')}
                onSelect={() => setColumnIdToAssociateConceptSchema(row.id)}
                onReset={() => onChange(row.id, EL_SEMANTIC_CONCEPT_EXISTING, null, null, null, null)}
                value={semanticDefinition.concept}
                render={concept => concept
                  ? concept.id
                  : ""}
              />
            </Fragment>
          );
        }
        else return null;
      },
      renderText: () => null          
    }
  ];

  const conceptColumn = [
    {
      dataIndex: "semanticDefinition",
      width: TABLE_COL_SELECTOR_WIDTH,
      noFilter: true,
      noSort: true,
      render: (semanticDefinition, row) => { 
          return (
            <Fragment>
              <Selector
                selectTitle={t('components.easyLoading.semantic.table.concept.selector.selectTitle')}
                resetTitle={t('components.easyLoading.semantic.table.concept.selector.resetTitle')}
                onSelect={() => setColumnIdToAssociateConceptSchema(row.id)}
                onReset={() => onChange(row.id, EL_SEMANTIC_CONCEPT_EXISTING, null, null, null, null)}
                value={semanticDefinition.concept}
                render={concept => concept
                  ? concept.id
                  : ""}
              />
            </Fragment>
          );
      },
      renderText: () => null          
    }
  ];

  const columns = [
    {
      dataIndex: "id",
      title: t("components.easyLoading.semantic.table.id.title"),
    },
  ].concat(
      canCreateConcepts
        ? conceptsCreationColumns
        : conceptColumn
    );

  return (
    <InfiniteScrollTable
        data={semanticColumns.map(column => ({
          ...column,
          conceptType: column.semanticDefinition.conceptType,
        }))}
        getRowKey={row => row.id}
        columns={columns}
      />
  );
};

export default compose(translate())(ELSemanticStepTable);



// WEBPACK FOOTER //
// ./src/components/easy-loading/semantic-step/Table.jsx